<template>
  <div class="culture_box">
    <div class="culture_content">
      <div class="title_icon">
        <div @click="clickshowModel(0)" class="icon">
          <i
            :class="showModel == 0 ? 'backgroundcolor' : ''"
            class="iconfont icon-tubiaozhizuomoban1"
          ></i>
          <span>思想理念</span>
        </div>
        <div @click="clickshowModel(1)" class="icon">
          <i
            :class="showModel == 1 ? 'backgroundcolor' : ''"
            class="iconfont icon-tubiaozhizuomoban"
          ></i>
          <span>运营管理</span>
        </div>
        <div @click="clickshowModel(2)" class="icon">
          <i
            :class="showModel == 2 ? 'backgroundcolor' : ''"
            class="iconfont icon-zhiyesuyang"
          ></i>
          <span>职业素养</span>
        </div>
      </div>
      <div class="centxt_list">
        <div v-show="showModel == 0" class="lixiang">
          <!-- <div class="lx_title">
              <span>金城金素之信----思想理念体系•厚德正念</span>
            </div> -->
          <div class="lx_cext">
            <div>
              <img
                style="width: 100%"
                src="../../assets/images/hfksdjhjkfa.png"
              />
              <img style="width: 100%" src="../../assets/images/9.png" />
            </div>
          </div>
        </div>
        <div v-show="showModel == 1" class="yunying">
          <div class="row team-row">
            <div class="col-lg-12 col-12 team-wrap mt-lg-5 mt-4 ui-timeLine">
              <div
                class="lists"
                v-for="(item, index) in guanliData"
                :key="index"
              >
                <div class="list_title">
                  <h2 style="color: #00758e">{{ item.yyName }}</h2>
                </div>
                <div
                  v-for="(item, index) in item.children"
                  :key="index"
                  class="item_list"
                  style="margin-bottom: 30px; margin-left: 45px"
                >
                  <h4>{{ item.yyName }}</h4>
                  <div id="aaaa" class="text">
                    <p class="cboxs" :style="{ left: show + 'vw' }">
                      {{ item.yyContent }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="showModel == 2" class="suyang">
          <div class="sy_title">
            <span>金城金素之信----思想理念体系•厚德正念</span>
          </div>
          <div class="sy_content">
            <div>
              <div class="content_left">
                <div class="title">金城金素人职业素养</div>
                <div class="content_list">
                  <ul>
                    <li>责任与担当</li>
                    <li>严谨与务实</li>
                    <li>执行与效率</li>
                    <li>沟通与合作</li>
                    <li>学习与活力</li>
                    <li>尊重与关怀</li>
                  </ul>
                </div>
              </div>
              <div class="content_right">
                <img
                  style="width: 100%"
                  src="../../assets/images/suyang01.png"
                />
              </div>
            </div>
            <div class="xian">
            </div>
            <div class="sy_content_bottom">
                <div class="title">金城金素人十二行为守则</div>
                <div class="bottom_txt">
                  <div class="txt">
                    <ul>
                      <li>第一条 遵纪守法，清正廉洁</li>
                      <li>第二条 专业勤勉，爱岗敬业</li>
                      <li>第三条 顾全大局，服从管理</li>
                      <li>第四条 严谨务实，守正创新</li>
                    </ul>
                  </div>
                  <div class="txt">
                    <ul>
                      <li>第五条 努力学习，自我提升</li>
                      <li>第六条 诚实守信，尊重他人</li>
                      <li>第七条 团结协作，高效执行</li>
                      <li>第八条 严守秘密，维护安全</li>
                    </ul>
                  </div>
                  <div class="txt">
                    <ul>
                      <li>第九条 坚持真理，坚守原则</li>
                      <li>第十条 爱护财物，反对浪费</li>
                      <li>第十一条 谦虚谨慎，修身立德</li>
                      <li>第十二条 汇聚力量，共享成长</li>
                    </ul>
                  </div>
                </div>
                <div class="images">
                  <img style="width:100%" src="../../assets/images/suyang02.jpg"/>
                </div>
                <div style="height:70px;line-height: 70px;" class="images">
                  <img style="width:50%;" src="../../assets/images/titlt_logo.png"/>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getyylist} from "@/api/yy/index"
export default {
  components: {},
  data() {
    return {
      showModel: 0,
      show: 100,
      guanliData: [],
    };
  },
  created() {
    this.getyylist()
  },
  methods: {
    getyylist(){
      getyylist({
        isDel:0,
      }).then(res =>{
        this.guanliData = this.handleTree(res.data, "yyId", "parentId");

        this.guanliData = this.guanliData.sort((a,b)=>{
          return a.orderNum - b.orderNum;
        })

        for(var i = 0 ; i < this.guanliData.length;i++){
            this.guanliData[i].children.sort((a , b) =>{
              return a.orderNum - b.orderNum;
            })
        }
      })
    },
    clickshowModel(e) {
      if (e == 1) {
        setTimeout(() => {
          this.show = 2;
        }, 10);
      } else {
        setTimeout(() => {
          this.show = 100;
        }, 10);
      }
      this.showModel = e;
    },
  },
};
</script>

<style lang="less" scoped>
.culture_box {
  width: 100%;
  height: 100%;
  background: #f4f2f2;
  position: relative;
  overflow: hidden;
  display: none;
}
.culture_content {
  width: 100%;
  // height:600px;
  margin: auto;
}
.title_icon {
  width: 40%;
  margin: 10px auto;
  text-align: center;
  justify-items: center;
  display: flex;
  .icon {
    width: 32%;
    margin-left: 1%;
    text-align: center;
    .iconfont {
      font-size: 100px;
      color: #651984;
      border: 4px solid #00758e;
      border-radius: 50%;
      text-align: center;
      cursor: pointer;
    }
    span {
      display: block;
      width: 100%;
      text-align: center;
      color: #651984;
      font-weight: 600;
      font-size: 18px;
      letter-spacing: 3px;
    }
  }
  .backgroundcolor {
    background: #0a529b;
    color: #fff !important;
  }
  .iconfont:hover {
    background: #0a529b;
    color: #fff;
  }
}
.centxt_list {
  width: 70%;
  margin: 20px auto;
  // background: red;
  .lixiang {
    width: 100%;
    margin: auto;
  }
}
.sy_title {
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-size: 18px;
  color: #651984;
}
.cboxs {
  position: relative;
  left: 100vw;
  transition: left 1s;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 3px 3px 8px #ccc;
  background: linear-gradient(180deg, #00758e 0, #018fac 100%);
  color: #fff;
  font-size: 18px;
}
.list_title {
  padding: 10px;
}
.suyang {
  .sy_content {
    .content_left {
      width: 50%;
      float: left;
      .title {
        padding-left: 30px;
        font-size: 20px;
        color: #651984;
      }
      .title::before {
        content: "";
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #0a529b;
        position: relative;
        top: 18px;
        left: -15px;
      }
      .content_list {
        width: 60%;
        margin: auto;
        ul {
          margin-top: 30px;
        }
        ul li {
          height: 30px;
          // padding: 10px;
          background: #00abaf;
          color: #fff;
          margin-top: 6px;
          line-height: 30px;
          border-radius: 5px;
          text-align: center;
          font-weight: 600;
          letter-spacing: 3px;
          font-size: 15px;
        }
      }
    }
    .content_right {
      width: 50%;
      float: left;
      .icon-weibiaoti-1 {
        font-size: 200px;
      }
    }
    .xian{
      width: 100%;
      height: 50px;
      clear: both;
      border-bottom: 1px #00758e dashed;
      margin-bottom: 40px;
    }
    .sy_content_bottom{
      .title {
        padding-left: 30px;
        font-size: 20px;
        color: #651984;
      }
      .title::before {
        content: "";
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #0a529b;
        position: relative;
        top: 18px;
        left: -15px;
      }
      .bottom_txt{
        text-align: center;
        justify-content: center;
        display: flex;
        .txt{
          margin: 20px;
          width: 30%;
          border: 3px #00758e solid;
          border-radius: 5px;
          font-size: 15px;
          ul li{
            line-height: 40px;
            text-align: left;
            padding-left: 13%;
            font-weight: 540;
            font-family: SimHei;
          }
        }
      }
      .images{
        margin-top: 20px;
        width: 100%;
        text-align: center;
        
      }
    }
  }
}
</style>